import React from 'react';
import { playerStyleFor } from '../themes';

const OpponentStrip = ({ players = [], submittedIds = new Set(), currentPlayerId }) => {
  if (!players.length) return null;

  return (
    <div style={{
      display: 'flex',
      gap: 8,
      padding: '0 14px 2px',
      alignItems: 'center',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
    }}>
      {players.map((p, i) => {
        const id = typeof p === 'string' ? p : p.id || p.name;
        const name = typeof p === 'string' ? p : p.name || p.id;
        const isMe = id === currentPlayerId;
        const placed = submittedIds.has(id);
        const style = playerStyleFor(i);
        return (
          <div key={id} style={{
            display: 'flex', alignItems: 'center', gap: 7,
            padding: '6px 11px 6px 6px',
            background: isMe ? 'var(--c-yellow)' : 'rgba(255, 255, 255, 0.7)',
            border: 'var(--border-ink)',
            borderRadius: 999,
            boxShadow: isMe ? 'var(--shadow-hard-sm)' : 'none',
            flexShrink: 0,
          }}>
            <div style={{
              width: 28, height: 28, borderRadius: 999,
              background: style.color,
              display: 'grid', placeItems: 'center',
              fontSize: 15,
              border: 'var(--border-ink-sm)',
            }}>{style.emoji}</div>
            <div style={{
              fontFamily: 'var(--font-display)', fontSize: 13, letterSpacing: 0.4,
              color: 'var(--c-ink)',
              maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>{(isMe ? 'YOU' : name).toString().toUpperCase()}</div>
            <div style={{
              fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 12,
              padding: '2px 6px', borderRadius: 5,
              background: placed ? 'var(--c-green)' : '#16131520',
              color: placed ? '#fff' : 'var(--c-ink)',
              minWidth: 16, textAlign: 'center',
            }}>{placed ? '✓' : '…'}</div>
          </div>
        );
      })}
    </div>
  );
};

export default OpponentStrip;
